<div class="iframe-cont">
    @if (url()) {
        <iframe class="iframe" frameborder="0" [style.height.px]="height()" [src]="url()"></iframe>
    }
</div>
